<template>
  <div>
    <v-container>
      <v-row no-gutters justify="">
        <v-card-title class="ma-0 pa-0">
          <h3 class="primary--text">
            {{ $t("settings.contactUs.title") }}
          </h3>
        </v-card-title>
      </v-row>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <div
            class="tw-w-full tw-grid tw-gap-x-4 mt-4 tw-grid-cols-1 lg:tw-grid-cols-2"
          >
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.email')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.email')"
                  color="secondary"
                  type="text"
                  v-model="contactUsModelObj.email"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.email") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('landlord.countryCode')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('landlord.countryCode')"
                  color="secondary"
                  type="text"
                  v-model="contactUsModelObj.countryCode"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.countryCode") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.phone')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.phone')"
                  color="secondary"
                  type="number"
                  class="numberClass"
                  v-model="contactUsModelObj.phone"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.phone") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('landlord.country')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('landlord.country')"
                  color="secondary"
                  type="text"
                  class="numberClass"
                  v-model="contactUsModelObj.country"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.country") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('landlord.address')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('landlord.address')"
                  color="secondary"
                  type="text"
                  class="numberClass"
                  v-model="contactUsModelObj.address"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.address") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.whatsapp')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.whatsapp')"
                  color="secondary"
                  type="number"
                  class="numberClass"
                  v-model="contactUsModelObj.whatsapp"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.whatsapp") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.instagram')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.instagram')"
                  color="secondary"
                  type="text"
                  v-model="contactUsModelObj.instagram"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.instagram") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.facebook')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.facebook')"
                  color="secondary"
                  v-model="contactUsModelObj.facebook"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.facebook") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.twitter')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.twitter')"
                  color="secondary"
                  v-model="contactUsModelObj.twiter"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.twitter") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.contactUs.linkedin')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.linkedin')"
                  color="secondary"
                  v-model="contactUsModelObj.linkdin"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.contactUs.linkedin") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <!-- <v-col cols="12" sm="6" md="3" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.contactUs.privacyPolicy')"
                  color="secondary"
                  type="text"
                  v-model="contactUsModelObj.privacyPolicy"
                >
                <template #label>
    <span class="red--text"><strong>* </strong></span>{{$t('landlord.paymentType') }}
  </template></v-text-field>
              </ValidationProvider>
            </v-col> -->
          </div>
          <div class="tw-flex tw-justify-end mt-4">
            <!-- <div class="d-flex"> -->
            <!-- <v-btn class="custom-button text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn> -->
            <v-btn
              class="white--text rounded-lg"
              color="primary"
              width="20%"
              type="submit"
              :loading="btnLoading"
            >
              {{ $t("common.update") }}
            </v-btn>
            <!-- </div> -->

            <v-col v-if="isError != null" cols="12" sm="12">
              <Alert :message="isError" />
            </v-col>
          </div>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
// import { mapGetters } from "vuex";
import { createContactUs } from "../../methods/contactUs/create_contact_us";
import { updateContactUs } from "../../methods/contactUs/update_contact_us";
export default {
  data() {
    return {
      btnLoading: false,
      contactUsModelObj: {
        email: "",
        phone: "",
        whatsapp: "",
        instagram: "",
        facebook: "",
        twiter: "",
        linkdin: "",
        address: "",
        country: ""
      },
      search: "",
      isError: null,
      name: "",
      reRender: 0
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  // mounted () {
  //   if (this.isEditContactUs) this.contactUsModelObj = this.$format.cloneVariable(this.editContactUs)
  // },
  // watch: {
  //   isEditContactUs: {
  //     handler() {
  //       if (this.isEditContactUs) {
  //         this.contactUsModelObj = this.$format.cloneVariable(this.editContactUs);
  //       } else {
  //         this.contactUsModelObj = {
  //           email: "",
  //           phone: "",
  //           whatsapp: "",
  //           instagram: ""
  //         };
  //         this.reRender++
  //       }
  //     },
  //     deep: true,
  //   }
  // },
  computed: {
    // ...mapGetters(["isEditContactUs", "editContactUs"]),
  },
  apollo: {
    getContactUs() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/contactUs/contact_us_query.graphql"),
        variables: {
          searchKey: this.search
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.contactUsModelObj = this.$format.cloneVariable(
            data.getContactUs
          );
          this.loading = false;
        }
      };
    }
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.contactUsModelObj)
      };
      if (!input.input._id) {
        createContactUs(input, this.search).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            email: input.input.email,
            phone: input.input.phone,
            whatsapp: input.input.whatsapp,
            instagram: input.input.instagram,
            privacyPolicy: input.input.privacyPolicy,
            facebook: input.input.facebook,
            twiter: input.input.twiter,
            linkdin: input.input.linkdin,
            address: input.input.address,
            countryCode: input.input.countryCode,
            country: input.input.country
          }
        };
        updateContactUs(updateInput, this.search).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$store.commit("IS_EDIT_CONTACT_US", false);
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_CONTACT_US", false);
    // },
  }
};
</script>
<style scoped>
.numberClass >>> input[type="number"] {
  -moz-appearance: textfield;
}

.numberClass >>> input::-webkit-outer-spin-button,
.numberClass >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
